import { toast } from 'react-toastify';
import ToastMessage from './ToastMessage';
import { ToastTypeEnum } from './types';

class Toastify {
  success(message: string) {
    toast(<ToastMessage text={message} type={ToastTypeEnum.SUCCESS} />);
  }

  error(message: string) {
    toast(<ToastMessage text={message} type={ToastTypeEnum.ERROR} />);
  }

  info(message: string) {
    toast(<ToastMessage text={message} type={ToastTypeEnum.INFO} />);
  }

  warning(message: string) {
    toast(<ToastMessage text={message} type={ToastTypeEnum.WARNING} />);
  }
}

export const toastify = new Toastify();
